import { serializeUrl } from '../internal/serialize-url'
import { BookingParams, bookingUrlParamsSchema } from '../schemas/booking-params'

export const buildBookingUrl = (params: BookingParams): string => {
  const { classId, type, classType, teacherId, referrer, designated, tutorId } = bookingUrlParamsSchema.parse(params)

  return serializeUrl('/booking', {
    required: {},
    optional: { classId, type, classType, teacherId, referrer, designated: designated ? 'true' : undefined, tutorId },
  })
}
